'use strict';

const { captureMessage } = require('../analytics/sentry');
const isEmptyField = require('../helpers/isEmptyField');
const viewport = require('../helpers/responsiveViewport'); // useg for legacy genbar toggle
const scrollTo = require('../helpers/scrollTo'); // useg for legacy genbar toggle

const $genbar = $('.generation-bar');
const $genbarInput = $genbar.find('input');

const $header = $('.-header'); // new Header
const $toggleGenbarBtn = $header.find('.js-toggle-genbar'); // new Header toggle button
const $headerGenbarInput = $('.js-generation-bar-in-header').find('input');

function init () {
  if ($genbar.length > 0) {
    if ($header.length > 0) {
      initGenbarToggle();
    }

    $genbarInput.on('change paste keyup focus blur', (e) => {
      const $form = $(e.target).parents('.generation-bar');
      const $input = $form.find('input');
      const $btn = $form.find('.generation-bar-btn');
      $btn.toggleClass('disabled', $input.val() === '');
    });

    // old behavior to toggle genbar with mobile-style class
    initGenbarToggleLegacy();

    // generation-bar submit button
    $genbar.on('submit', function (event, params) {
      event.preventDefault();

      const $thisGenBar = $(this);

      let isEmptyRequest = false;
      params = params || '';

      if (!$thisGenBar.hasClass('busy')) {
        if (params.length <= 0) {
          isEmptyRequest = genbarValidation($thisGenBar);

          if (isEmptyRequest) {
            return false;
          }

          params = $thisGenBar.serialize();
        }

        $thisGenBar.addClass('busy');

        generationAjaxCall(params, $thisGenBar);
      }
    });
  }

  // Start of stuff from legacy Header
  const $top = $('#top');

  $('#top-nav-collapse .navbar-nav .dropdown-menu a').on('click', function (event) {
    return event.stopPropagation();
  });

  $top.find('#top-nav-collapse').on('shown.bs.collapse', function () {
    if (!$top.find('#logged-container .dropdown-menu').hasClass('open')) {
      $top.find('#logged-container .dropdown-menu').dropdown('toggle');
    }
  });
  // End of stuff from legacy Header
}

function initGenbarToggle () {
  $headerGenbarInput.on('focus', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (!$header.hasClass('_genbar-open_')) {
      toggleGenbarInHeader(true);
    }
  }).on('blur', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($header.hasClass('_genbar-open_')) {
      toggleGenbarInHeader(false);
    }
  });
  // Show/Hide generation-bar in new Header
  $toggleGenbarBtn.on('click', function (e) {
    e.preventDefault();
    toggleGenbarInHeader(!$header.hasClass('_genbar-open_'));
  });

  // Show/Hide generation-bar when resize window
  $(window).on('resize', function () {
    if ($header.hasClass('_genbar-open_')) toggleGenbarInHeader(false);
  });

  // Show/Hide generation-bar when click elsewhere but itself on New Header
  $(document).on('click', function (event) {
    if (
      $headerGenbarInput.length > 1 &&
      !$(event.target).parents('.generation-bar').length &&
      !$(event.target).parents('.js-toggle-genbar').length &&
      !$(event.target).parents('.-header').length &&
      $header.hasClass('_genbar-open_')
    ) {
      toggleGenbarInHeader(false);
    }
  });
}

function initGenbarToggleLegacy () {
  const $navbar = $('#top .navbar');
  let isTablet = viewport.isTablet();
  const fullPagePanel = function (bool) {
    $('body').toggleClass('no-scrolls', bool);
    if (bool) {
      scrollTo('#top', 0);
    }
  };

  $(window).on('resize', function () {
    isTablet = viewport.isTablet();

    if (isTablet) {
      $navbar.removeClass('genbar-mobile-style');
      fullPagePanel(false);
    }
  });

  // open genbar in mobile
  $navbar.on('click', '.js-toggle-genbar', function (event) {
    const toggleMobileGenbar =
    !isTablet && !$navbar.hasClass('genbar-mobile-style');
    $navbar.toggleClass('genbar-mobile-style', toggleMobileGenbar);
    fullPagePanel($navbar.hasClass('genbar-mobile-style'));
  });

  // close genbar in mobile on menu open
  $navbar.on('click', '.navbar-toggle', function () {
    $navbar.removeClass('genbar-mobile-style');
    fullPagePanel(false);
  });
}

function genbarValidation ($thisGenBar) {
  if ($thisGenBar.length > 0) {
    const $requiredInput = $thisGenBar.find('.js-validate-review-url');
    let isEmptyRequest = false;

    $thisGenBar
      .removeClass('error')
      .find('.error')
      .removeClass('error');

    if (isEmptyField($requiredInput)) {
      isEmptyRequest = true;
      $thisGenBar.addClass('error');
      $requiredInput.addClass('error');
    }

    return isEmptyRequest;
  }
}

function toggleGenbarInHeader (status) {
  $header.toggleClass('_genbar-open_', status);
  if ($('body').hasClass('appnav-open')) {
    $('body').toggleClass('appnav-open', false);
  }
  status ? $headerGenbarInput.focus() : $headerGenbarInput.val('');
}

function generationAjaxCall (params, context) {
  const data = params + '&ajax=1';

  $.ajax({
    type: 'POST',
    data: data,
    cache: false,
    url: context.attr('action'),
    context: context,
    dataType: 'json',
    success: function (data) {
      window.location.replace(data.url);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      captureMessage('Genbar in header post error', {
        extra: {
          textStatus: textStatus,
          errorThrown: errorThrown,
          params: params
        }
      });
      context.removeClass('busy');
      return $('#generic-error-modal').modal('show');
    }
  });
}

module.exports = {
  init: init,
  generationAjaxCall: generationAjaxCall
};
